module.exports = __webpack_public_path__ + "static/media/money-bag-outline.337983cc.svg";